import {Pagination} from '../../../../pagination.interface';

interface ContactMomentInterface {
    id: number;
    parentId: number;
    schemaId: number;
    dayNr: number;
    timeHour: number;
    timeMinute: number;
    deviation: number;
    isAbsoluteTime: boolean;
    contactFilters: any;
}

class ContactMoment implements ContactMomentInterface {
    static readonly TYPE_NORMAL = 'normal';
    static readonly TYPE_FREE   = 'free';

    static readonly types: string[] = [
        ContactMoment.TYPE_NORMAL,
        ContactMoment.TYPE_FREE
    ];

    id: number;
    parentId: number;
    schemaId: number;
    dayNr: number;
    timeHour: number;
    timeMinute: number;
    deviation: number;
    isAbsoluteTime: boolean;
    contactFilters: any = {};
}

class ContactMomentCollection {
    result: ContactMoment[];
    pagination: Pagination;
}

export {
    ContactMoment,
    ContactMomentCollection
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/proxy/schemas/contactMoments/api.models.ts